import { render, staticRenderFns } from "./purchasePaymentHistory.vue?vue&type=template&id=6fd506ae&"
import script from "./purchasePaymentHistory.vue?vue&type=script&lang=js&"
export * from "./purchasePaymentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports